import { AdditionalInfoCard, ContactsCard, DateAndTimeCard, ExtraServicesCard, KeysCard, NotesCard, PhotoCountCard, PropertyAddressCard, VirtualStagingFurnitureCard } from "../../Order/Cards";
import { FC, memo } from "react";
import { ORDERSERVICE_TYPE } from "@/types";
import { OrderCustomerProps } from "../OrderCustomer.interface";

const InProgress: FC<OrderCustomerProps> = ({
    addressString,
    appointmentDate,
    appointmentDuration,
    appointmentTime,
    bedrooms,
    contacts,
    contactVendorDirectly,
    doorNumber,
    flat,
    floorArea,
    furnitureNames,
    imageMotionRequested,
    isAdmin,
    keyNotes,
    keys,
    keysTime,
    keysTimeOption,
    keysWith,
    keysWithDetail,
    notes,
    notifyViaSMS,
    onAddFurnitures,
    onAddNote,
    onUpdatePhotoCount,
    onCancelNote,
    onSaveNote,
    orderDetails,
    owner,
    parking,
    photoCount,
    poNumber,
    sendNotifications,
    videoMotionRequested,
    virtualStagingRequested,
    virtualTourPartial
}) => {
    const accordionState = 'open';

    const orderService = orderDetails.services.find((item) => item.type === ORDERSERVICE_TYPE.VIRTUAL_STAGING);
    const orderServiceId = orderService?.orderServiceId || '';
    furnitureNames && (furnitureNames.value = orderService?.externalLink || '');

  return (<>  
        { orderDetails.isVirtual && orderDetails.orderTemplateId === 10468 && <PhotoCountCard
          accordionState={accordionState}
          photoCount={photoCount}
          isReadOnly={true}
          onUpdatePhotoCount={onUpdatePhotoCount}
          />}

        { orderDetails.isVirtual && <VirtualStagingFurnitureCard
          accordionState={accordionState}
          furnitureNames={furnitureNames}
          onAddFurnitures={onAddFurnitures}
          orderServiceId={orderServiceId}
          isReadOnly={true}
          />}

        { !orderDetails.isVirtual &&  <DateAndTimeCard
            accordionState={accordionState}
            appointmentDate={appointmentDate}
            appointmentTime={appointmentTime}
            appointmentDuration={appointmentDuration}
            contactVendorDirectly={contactVendorDirectly}
            notifyViaSMS={notifyViaSMS} 
            isReadOnly={true}
        /> }

        { !orderDetails.isVirtual &&  <PropertyAddressCard
            accordionState={accordionState}
            addressString={addressString}
            flat={flat}
            doorNumber={doorNumber}
            isReadOnly={true}
            /> }

        { !orderDetails.isVirtual && <KeysCard
                accordionState={accordionState}
                isReadOnly={true}
                keys={keys}
                keysTime={keysTime}
                keysTimeOption={keysTimeOption}
                keysWith={keysWith}
                keysWithDetail={keysWithDetail}
                keyNotes={keyNotes}
                /> }


         { !orderDetails.isVirtual &&  <AdditionalInfoCard
                accordionState={accordionState}
                isReadOnly={true}
                poNumber={poNumber}
                bedrooms={bedrooms}
                floorArea={floorArea}
                parking={parking}
                virtualTourPartial={virtualTourPartial}
                />
         }
        
            <ContactsCard
                accordionState={accordionState}
                contacts={contacts}
                isAdmin={isAdmin}
                isReadOnly={true}
                sendNotifications={sendNotifications}
                />
            <NotesCard
                accordionState={accordionState}
                isReadOnly={false}
                notes={notes}
                onAddNote={onAddNote}
                onCancelNote={onCancelNote}
                onSaveNote={onSaveNote}
                owner={owner}
            />
            
            
            <ExtraServicesCard 
                accordionState={accordionState}
                imageMotionRequested={imageMotionRequested}
                isReadOnly={true}
                videoMotionRequested={videoMotionRequested}
                virtualStagingRequested={virtualStagingRequested}
                />
            </>);
}

export default memo(InProgress);